export default __webpack_public_path__ + "static/media/editIconActive.a7f1beff.svg";